import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-colum h-100" }
const _hoisted_2 = { class: "d-flex justify-content-between bd-highlight mb-3" }
const _hoisted_3 = {
  class: "align-self-center mb-3",
  style: {"height":"30px"}
}
const _hoisted_4 = {
  class: "input-group align-self-center ms-auto p-2 bd-highlight",
  style: {"width":"25%"}
}
const _hoisted_5 = { class: "table table-bordered table-striped table-sm member-list" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "序号"),
    /*#__PURE__*/_createElementVNode("th", null, "客户ID"),
    /*#__PURE__*/_createElementVNode("th", null, "客户姓名"),
    /*#__PURE__*/_createElementVNode("th", null, "门店"),
    /*#__PURE__*/_createElementVNode("th", null, "类型"),
    /*#__PURE__*/_createElementVNode("th", null, "项目"),
    /*#__PURE__*/_createElementVNode("th", null, "产康赠送金"),
    /*#__PURE__*/_createElementVNode("th", null, "状态"),
    /*#__PURE__*/_createElementVNode("th", null, "录入人"),
    /*#__PURE__*/_createElementVNode("th", null, "手工费"),
    /*#__PURE__*/_createElementVNode("th", null, "操作日期"),
    /*#__PURE__*/_createElementVNode("th", null, "操作")
  ])
], -1)
const _hoisted_7 = { id: "member-list" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"deepskyblue"} }, /*#__PURE__*/_toDisplayString("待消耗"), -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"green"} }, /*#__PURE__*/_toDisplayString("已消耗"), -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"firebrick"} }, /*#__PURE__*/_toDisplayString("已取消"), -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "flex-row flex-align-center" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!
  const _component_ShowDetailDialog = _resolveComponent("ShowDetailDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAddChankangDialog && _ctx.openAddChankangDialog(...args)))
          }, "添加")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "article-keywords",
            class: "form-control",
            placeholder: "搜索",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.keywords) = $event))
          }, null, 512), [
            [_vModelText, _ctx.keywords]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadChankangList(1)))
          }, "搜索")
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataList, (value, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("td", null, _toDisplayString(50 * ($setup.nowPage - 1) + idx + 1), 1),
                _createElementVNode("td", null, _toDisplayString(value.customer), 1),
                _createElementVNode("td", null, _toDisplayString($setup.shortenName(value.customerName||"")), 1),
                _createElementVNode("td", null, _toDisplayString(value.shopName), 1),
                _createElementVNode("td", null, _toDisplayString(value.type) + "(" + _toDisplayString(value.subtype) + ")", 1),
                _createElementVNode("td", null, _toDisplayString(value.title), 1),
                _createElementVNode("td", null, _toDisplayString(value.ckzsj_used > 0 ? `-${value.ckzsj_used}元` : "-"), 1),
                (value.status == 0)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_8, _hoisted_10))
                  : (value.status == 1)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_11, _hoisted_13))
                    : (_openBlock(), _createElementBlock("td", _hoisted_14, _hoisted_16)),
                _createElementVNode("td", null, _toDisplayString(value.lururen), 1),
                _createElementVNode("td", null, _toDisplayString(value.shougong) + "元", 1),
                _createElementVNode("td", null, _toDisplayString(value.operateDate), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("img", {
                      class: "button-icon img-margin",
                      src: "/assets/ic_trash.png",
                      onClick: ($event: any) => ($setup.deleteChankang(value.id, value.customerName))
                    }, null, 8, _hoisted_18),
                    _createElementVNode("img", {
                      class: "button-icon img-margin",
                      src: "/assets/ic_edit.png",
                      onClick: ($event: any) => ($setup.showDetial(value))
                    }, null, 8, _hoisted_19)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_Pagination, {
          page: $setup.nowPage,
          max: $setup.totalPage/50,
          onLoadPage: $setup.loadChankangList
        }, null, 8, ["page", "max", "onLoadPage"])
      ])
    ]),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"]),
    (_ctx.showDetailDialog)
      ? (_openBlock(), _createBlock(_component_ShowDetailDialog, {
          key: 0,
          onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDetailDialog=false)),
          json: _ctx.editing
        }, null, 8, ["json"]))
      : _createCommentVNode("", true)
  ], 64))
}